import { Component, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import * as req from 'src/app/entities/request';
import { PrinterTemplateMap } from 'src/app/entities/response';
import { ActiveInactiveFor, LocalService, Status, TriggeredEvent } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-printer-template-map',
  templateUrl: './printer-template-map.component.html',
  styleUrl: './printer-template-map.component.scss'
})
export class PrinterTemplateMapComponent {
  @Input() ctryCode: string; @Input() businessId: string; @Input() isOfflineServiceAvailable: boolean | null = null;
  maxBodyHeight = 0;
  @Output() onPreDataRequired = new EventEmitter();
  @Output() onSaved = new EventEmitter();

  isOpenTemplateMapPopup = false;
  isOpenConfirmationBox = false;
  confirmationKey: string = '';

  itemSource: PrinterTemplateMap[] = [];
  items: PrinterTemplateMap[] = [];
  selectedItemId: string | undefined = undefined;
  isIncludeInActive = false;
  searchKey: string = '';

  htmlId: string = '';
  elementIds: any;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private printerService: PrinterService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      banner_id: 'banner-' + this.htmlId
    };
  }

  ngOnInit() {
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad(isConsiderSave = false) {
    const req = {
      BusinessId: this.businessId,
      CountryCode: this.localService.getLoginAsCountryCode(),
      IsIncludeInActive: this.isIncludeInActive
    } as req.BusinessDetail;
    this.printerService.getPrinterTemplateMaps(req).subscribe(result => {
      this.itemSource = result;
      this.onFilter();
    });

    if (isConsiderSave) {
      this.onSaved.emit();
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedItemId = undefined;
        this.isOpenTemplateMapPopup = true;
      } break;
      case 2: {
        this.selectedItemId = key;
        this.isOpenTemplateMapPopup = true;
      } break;
      case 3: {
        //Filter
      } break;
      case 4: {
        //Delete
        this.confirmationKey = key;
        this.isOpenConfirmationBox = true;
      } break;
      case 5: {
        //Restore
        this.onActiveInactiveStatus(key);
      } break;
      case 6: {
        //Delete confirmed
        this.onActiveInactiveStatus(key);
      }
    }
  }

  onActiveInactiveStatus(key: string) {
    const req = {
      BusinessId: this.businessId
    } as req.BusinessDetail;
    this.printerService.activeInactiveStatus(req, key, ActiveInactiveFor.PrinterTemplateMap).subscribe(result => {
      if (result && result.status == Status.Success) {
        this.onLoad(true);
      }
      if (result && result.status) {
        this.localService.showInformationByStatus(result.status);
      }
    });
  }

  onFilter(isClearSearch = false) {
    if (isClearSearch) {
      this.searchKey = '';
    }
    const key = this.searchKey.trim().toLowerCase();
    const items = key ? this.itemSource.filter(x => x.STitle.includes(key)) : this.itemSource;
    this.items = items;
  }

  onDelete(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.onAction(6, this.confirmationKey);
    }
  }
}
